var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _g2, _rect8, _rect9, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 236,
    viewBox: "0 0 250 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3606_70943)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.2593,
    y: 19.5284,
    width: 121.707,
    height: 155.548,
    rx: 4.5,
    transform: "rotate(7 96.2593 19.5284)",
    fill: "#D0D5DD",
    stroke: "white",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3606_70943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 16,
    width: 147,
    height: 176
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2593,
    y: 19.5284,
    width: 121.707,
    height: 155.548,
    rx: 4.5,
    transform: "rotate(7 96.2593 19.5284)",
    fill: "white",
    stroke: "white",
    strokeWidth: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3606_70943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.71 52.9072L143.006 31.3212L151.145 54.9592L118.71 52.9072Z",
    fill: "#ACFF8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.809 93.6544L155.706 63.8229L173.072 81.8064L142.809 93.6544Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.433 119.706L181.649 87.207L204.661 96.9753L181.433 119.706Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.684 14.4C142.684 14.4 144.572 75.3682 205.638 96.0703",
    stroke: "white",
    strokeWidth: 3
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4121,
    y: 132.18,
    width: 122.22,
    height: 40.3057,
    transform: "rotate(7 82.4121 132.18)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.5586,
    y: 145.526,
    width: 96,
    height: 7,
    rx: 3.5,
    transform: "rotate(7 84.5586 145.526)",
    fill: "#E5E9F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3535,
    y: 158.624,
    width: 56,
    height: 7,
    rx: 3.5,
    transform: "rotate(7 83.3535 158.624)",
    fill: "#E5E9F5"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3606_70943)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4625,
    y: 34.4191,
    width: 121.707,
    height: 155.548,
    rx: 4.5,
    transform: "rotate(-7 28.4625 34.4191)",
    fill: "#53B1FD",
    stroke: "white",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3606_70943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 16,
    width: 147,
    height: 176
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4625,
    y: 34.4191,
    width: 121.707,
    height: 155.548,
    rx: 4.5,
    transform: "rotate(-7 28.4625 34.4191)",
    fill: "white",
    stroke: "white",
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3606_70943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.628 -24.4894C127.12 -25.5321 135.191 -22.9042 141.156 -17.8803C146.889 -24.4074 155.026 -28.9582 164.43 -30.1128C184.426 -32.568 202.578 -18.7391 204.974 0.775018C205.09 1.71709 205.167 2.65518 205.206 3.58777C218.32 7.65938 228.449 18.8681 230.197 33.1012C232.593 52.6153 218.325 70.4249 198.33 72.8801C184.726 74.5503 171.977 68.6843 164.46 58.6191C159.658 63.1693 153.133 66.3558 145.696 67.2689C132.823 68.8496 120.954 63.16 115.306 53.7615C114.393 53.9691 113.46 54.1326 112.51 54.2493C97.9516 56.0368 84.7613 46.176 83.0483 32.2245C81.9003 22.875 86.1981 14.0611 93.5396 8.72575C93.43 8.14527 93.3384 7.55762 93.2654 6.96329C91.3723 -8.45525 102.727 -22.5371 118.628 -24.4894Z",
    fill: "url(#paint0_linear_3606_70943)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.625 112.673C133.459 100.377 153.04 96.9237 170.245 103.748L255.905 137.722L50.7513 173.896L119.625 112.673Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 75,
    width: 38,
    height: 47,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 98,
    width: 38,
    height: 47,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7695 66.4884C75.8246 66.3589 76.8883 66.657 77.7266 67.3173C78.5649 67.9776 79.1093 68.9459 79.2398 70.0092L88.1006 142.175C88.2312 143.238 87.9373 144.309 87.2836 145.153C86.6299 145.996 85.6699 146.543 84.6148 146.672L78.6478 147.405L76.6787 131.368C76.6134 130.836 76.3413 130.352 75.9221 130.022C75.5029 129.692 74.9711 129.543 74.4435 129.608L68.4765 130.34C67.9489 130.405 67.469 130.678 67.1421 131.1C66.8153 131.522 66.6683 132.058 66.7336 132.589L68.7026 148.626L46.8234 151.312C45.7683 151.442 44.7046 151.144 43.8663 150.484C43.0279 149.823 42.4836 148.855 42.3531 147.792L33.4923 75.6263C33.3617 74.563 33.6556 73.4917 34.3093 72.6483C34.963 71.8048 35.923 71.2582 36.978 71.1286L74.7695 66.4884ZM55.8239 109.511L49.8568 110.244C49.3293 110.308 48.8493 110.582 48.5224 111.003C48.1956 111.425 48.0486 111.961 48.1139 112.492L48.8523 118.506C48.9176 119.038 49.1898 119.522 49.6089 119.852C50.0281 120.182 50.56 120.331 51.0875 120.267L57.0546 119.534C57.5821 119.469 58.0621 119.196 58.3889 118.774C58.7158 118.352 58.8627 117.817 58.7974 117.285L58.059 111.271C57.9938 110.74 57.7216 110.256 57.3024 109.925C56.8833 109.595 56.3514 109.446 55.8239 109.511ZM71.7361 107.557L65.769 108.29C65.2415 108.355 64.7615 108.628 64.4346 109.05C64.1078 109.471 63.9608 110.007 64.0261 110.539L64.7645 116.552C64.8298 117.084 65.102 117.568 65.5211 117.898C65.9403 118.229 66.4721 118.378 66.9997 118.313L72.9667 117.58C73.4943 117.515 73.9743 117.242 74.3011 116.82C74.628 116.399 74.7749 115.863 74.7096 115.331L73.9712 109.318C73.906 108.786 73.6338 108.302 73.2146 107.972C72.7955 107.642 72.2636 107.492 71.7361 107.557ZM69.767 91.5204L63.7999 92.2531C63.2724 92.3179 62.7924 92.5912 62.4656 93.0129C62.1387 93.4347 61.9918 93.9703 62.057 94.5019L62.7954 100.516C62.8607 101.047 63.1329 101.532 63.5521 101.862C63.9712 102.192 64.5031 102.341 65.0306 102.276L70.9977 101.543C71.5252 101.479 72.0052 101.205 72.332 100.784C72.6589 100.362 72.8058 99.8262 72.7406 99.2946L72.0022 93.2808C71.9369 92.7492 71.6647 92.265 71.2456 91.9349C70.8264 91.6047 70.2945 91.4557 69.767 91.5204ZM53.8548 93.4742L47.8877 94.2069C47.3602 94.2716 46.8802 94.545 46.5534 94.9667C46.2265 95.3884 46.0796 95.924 46.1449 96.4557L46.8833 102.469C46.9485 103.001 47.2207 103.485 47.6399 103.815C48.059 104.146 48.5909 104.295 49.1184 104.23L55.0855 103.497C55.613 103.432 56.093 103.159 56.4198 102.737C56.7467 102.316 56.8937 101.78 56.8284 101.248L56.09 95.2346C56.0247 94.7029 55.7525 94.2188 55.3334 93.8887C54.9142 93.5585 54.3823 93.4094 53.8548 93.4742ZM51.8858 77.4375L45.9187 78.1701C45.3912 78.2349 44.9112 78.5082 44.5843 78.9299C44.2575 79.3517 44.1105 79.8873 44.1758 80.4189L44.9142 86.4327C44.9795 86.9644 45.2516 87.4485 45.6708 87.7786C46.09 88.1088 46.6218 88.2579 47.1493 88.1931L53.1164 87.4604C53.6439 87.3957 54.1239 87.1223 54.4508 86.7006C54.7776 86.2789 54.9246 85.7433 54.8593 85.2116L54.1209 79.1978C54.0556 78.6662 53.7835 78.182 53.3643 77.8519C52.9451 77.5218 52.4133 77.3727 51.8858 77.4375ZM67.7979 75.4837L61.8309 76.2163C61.3034 76.2811 60.8234 76.5544 60.4965 76.9762C60.1697 77.3979 60.0227 77.9335 60.088 78.4652L60.8264 84.4789C60.8917 85.0106 61.1638 85.4947 61.583 85.8249C62.0022 86.155 62.534 86.3041 63.0615 86.2393L69.0286 85.5067C69.5561 85.4419 70.0361 85.1686 70.363 84.7468C70.6898 84.3251 70.8368 83.7895 70.7715 83.2578L70.0331 77.2441C69.9678 76.7124 69.6957 76.2283 69.2765 75.8981C68.8573 75.568 68.3255 75.4189 67.7979 75.4837Z",
    fill: "url(#paint1_linear_3606_70943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.514 85.1425C120.615 85.4345 120.686 85.7365 120.724 86.0435L127.471 140.995C127.611 142.137 127.296 143.288 126.594 144.194C125.891 145.1 124.86 145.687 123.727 145.826L83.1308 150.811C81.9974 150.95 80.8548 150.63 79.9543 149.921C79.0537 149.211 78.469 148.171 78.3287 147.029L72.6738 100.973C72.5532 99.9898 72.77 98.9953 73.2882 98.1547C73.8064 97.3141 74.5948 96.678 75.5223 96.3521L115.026 82.4741C115.56 82.2864 116.125 82.2065 116.69 82.239C117.255 82.2715 117.808 82.4157 118.317 82.6635C118.827 82.9112 119.284 83.2577 119.661 83.683C120.038 84.1083 120.329 84.6041 120.516 85.1422L120.514 85.1425ZM112.007 121.035L105.598 121.823C105.031 121.892 104.515 122.186 104.164 122.639C103.813 123.092 103.655 123.667 103.725 124.238L104.519 130.698C104.589 131.269 104.881 131.789 105.331 132.144C105.782 132.499 106.353 132.659 106.92 132.589L113.329 131.802C113.896 131.733 114.412 131.439 114.763 130.986C115.114 130.533 115.272 129.958 115.202 129.387L114.408 122.926C114.338 122.355 114.046 121.835 113.596 121.481C113.145 121.126 112.574 120.966 112.007 121.035ZM94.9144 123.134L88.5045 123.921C87.9378 123.991 87.4222 124.284 87.0711 124.737C86.72 125.191 86.5622 125.766 86.6323 126.337L87.4255 132.797C87.4956 133.368 87.788 133.888 88.2382 134.243C88.6885 134.597 89.2598 134.758 89.8265 134.688L96.2364 133.901C96.8031 133.831 97.3187 133.538 97.6698 133.085C98.0209 132.632 98.1788 132.056 98.1086 131.485L97.3154 125.025C97.2453 124.454 96.953 123.934 96.5027 123.579C96.0524 123.225 95.4811 123.065 94.9144 123.134ZM92.7992 105.907L86.3893 106.694C85.8227 106.764 85.3071 107.058 84.9559 107.511C84.6048 107.964 84.447 108.539 84.5171 109.11L85.3103 115.57C85.3804 116.141 85.6728 116.661 86.1231 117.016C86.5733 117.371 87.1446 117.531 87.7113 117.461L94.1212 116.674C94.6879 116.605 95.2035 116.311 95.5546 115.858C95.9057 115.405 96.0636 114.83 95.9934 114.258L95.2002 107.798C95.1301 107.227 94.8378 106.707 94.3875 106.353C93.9372 105.998 93.3659 105.838 92.7992 105.907ZM109.892 103.809L103.482 104.596C102.916 104.665 102.4 104.959 102.049 105.412C101.698 105.865 101.54 106.44 101.61 107.011L102.403 113.471C102.473 114.043 102.766 114.563 103.216 114.917C103.666 115.272 104.238 115.432 104.804 115.362L111.214 114.575C111.781 114.506 112.297 114.212 112.648 113.759C112.999 113.306 113.157 112.731 113.086 112.16L112.293 105.7C112.223 105.129 111.931 104.608 111.481 104.254C111.03 103.899 110.459 103.739 109.892 103.809Z",
    fill: "url(#paint2_linear_3606_70943)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.279,
    y: 147.075,
    width: 122.22,
    height: 40.3057,
    transform: "rotate(-7 42.279 147.075)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5895,
    y: 159.506,
    width: 96,
    height: 7,
    rx: 3.5,
    transform: "rotate(-7 47.5895 159.506)",
    fill: "#E5E9F5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5895,
    y: 172.505,
    width: 56,
    height: 7,
    rx: 3.5,
    transform: "rotate(-7 49.5895 172.505)",
    fill: "#E5E9F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3606_70943",
    x: 45.3168,
    y: 2.54248,
    width: 203.728,
    height: 233.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172116 0 0 0 0 0.224928 0 0 0 0 0.401945 0 0 0 0.048998 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3606_70943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3606_70943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3606_70943",
    x: 0.476562,
    y: 0.600708,
    width: 195.728,
    height: 225.193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172116 0 0 0 0 0.224928 0 0 0 0 0.401945 0 0 0 0.160921 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3606_70943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3606_70943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3606_70943",
    x1: 92.1531,
    y1: 16.9869,
    x2: 100.491,
    y2: 84.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.158486
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3606_70943",
    x1: 55.8738,
    y1: 68.8085,
    x2: 65.7191,
    y2: 148.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3606_70943",
    x1: 95.6243,
    y1: 84.7562,
    x2: 103.429,
    y2: 148.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtwork);
export default __webpack_public_path__ + "static/media/Artwork.5c63ace5a814f105ec96afaeaccfdc47.svg";
export { ForwardRef as ReactComponent };